/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Paid_Gate_TInputs */



/**
* | output |
* | --- |
* | "Take the money at the door" |
*
* @param {Tournament_Wiz_Tip_Paid_Gate_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_paid_gate_t = /** @type {((inputs?: Tournament_Wiz_Tip_Paid_Gate_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Paid_Gate_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Encaissez à l'accueil")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cobre en la puerta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Receba o dinheiro na entrada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incassa all'ingresso")
	return /** @type {LocalizedString} */ ("Take the money at the door")
});